// Keep original adjacency: filtering points first invents sewn connections.
export function technicalSegments(stitches, { color = 'all', progress = stitches.length } = {}) {
  const segments = [];
  for (let i = 0; i < Math.min(progress, stitches.length); i++) {
    const end = stitches[i];
    const start = i ? stitches[i - 1] : { x: 0, y: 0, colorIndex: end.colorIndex };
    if (color !== 'all' && end.colorIndex !== Number(color)) continue;
    if (start.colorIndex !== end.colorIndex && !end.jump) continue;
    segments.push({ start, end, index: i, lengthMm: Math.hypot(end.x - start.x, end.y - start.y) / 10 });
  }
  return segments;
}

export function drawTechnicalStitches(ctx, data, options, { W, H, zoom, mapX, mapY }) {
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
  ctx.lineCap = 'butt'; ctx.lineJoin = 'miter';
  // 1 mm grid, with 5 mm divisions; coordinates are native 0.1 mm units.
  ctx.lineWidth = .5 / zoom;
  for (let axis = 0; axis < 2; axis++) {
    const min = axis ? data.minY : data.minX, max = axis ? data.maxY : data.maxX;
    for (let v = Math.ceil(min / 10) * 10; v <= max; v += 10) {
      ctx.strokeStyle = v % 50 === 0 ? '#cbd5e1' : '#edf0f4';
      ctx.beginPath();
      if (axis) { ctx.moveTo(mapX(data.minX), mapY(v)); ctx.lineTo(mapX(data.maxX), mapY(v)); }
      else { ctx.moveTo(mapX(v), mapY(data.minY)); ctx.lineTo(mapX(v), mapY(data.maxY)); }
      ctx.stroke();
    }
  }
  const palette = ['#a21caf', '#9a6700', '#172554', '#007c70', '#c2410c', '#4338ca'];
  const segments = technicalSegments(data.stitches, options);
  for (const { start, end, index } of segments) {
    if (end.jump && !options.jumps) continue;
    const active = options.progress < data.stitches.length && index === options.progress - 1;
    ctx.strokeStyle = active ? '#ef4444' : end.jump ? '#dc2626' : palette[end.colorIndex % palette.length];
    ctx.lineWidth = (active ? 2 : .8) / zoom;
    ctx.setLineDash(end.jump ? [3 / zoom, 2 / zoom] : []);
    ctx.beginPath(); ctx.moveTo(mapX(start.x), mapY(start.y)); ctx.lineTo(mapX(end.x), mapY(end.y)); ctx.stroke();
    if (options.points && !end.jump) {
      ctx.fillStyle = ctx.strokeStyle; ctx.beginPath();
      ctx.arc(mapX(end.x), mapY(end.y), 1.5 / zoom, 0, Math.PI * 2); ctx.fill();
    }
  }
  ctx.setLineDash([]);
}
